module.exports = __webpack_public_path__ + "img/DN.814b61a4.jpg";